import React, { useEffect, useState } from "react";

const RedirectURLFallback = () => {
  const [count, setCount] = useState(3);
  const [intentUrl, setIntentUrl] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorParam = params.get("error");
    const errorDesc = params.get("error_description");
    const code = params.get("code");

    if (errorParam) {
      setIsError(true);
      setErrorMessage(errorDesc || errorParam);
    }

    const query = window.location.search;
    const url = `duepay://callback${query}`;
    setIntentUrl(url);

    // Auto-attempt redirect to custom app scheme
    if (!errorParam && code) {
      const redirectTimer = setTimeout(() => {
        window.location.href = url;
      }, 500);
      return () => clearTimeout(redirectTimer);
    }
  }, []);

  // Countdown timer
  useEffect(() => {
    if (isError || count === 0) return;

    const timer = setTimeout(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, isError]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        padding: "24px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "20px",
          padding: "40px 32px",
          maxWidth: "440px",
          width: "100%",
          boxShadow: "0 12px 35px rgba(0, 0, 0, 0.08)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "68px",
            height: "68px",
            borderRadius: "50%",
            backgroundColor: isError ? "#fee2e2" : "#ecfdf5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px auto",
          }}
        >
          {isError ? (
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          ) : (
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          )}
        </div>

        <h2 style={{ color: "#0f172a", fontSize: "24px", fontWeight: "700", marginBottom: "8px" }}>
          {isError ? "Bank Linking Cancelled" : "Authentication Successful!"}
        </h2>

        <p style={{ color: "#64748b", fontSize: "15px", lineHeight: "1.5", marginBottom: "28px" }}>
          {isError
            ? errorMessage || "Authentication was declined or cancelled. You can return to DuePay to try again."
            : "Your bank account has been connected securely. Returning to the DuePay app..."}
        </p>

        {!isError && count > 0 && (
          <div
            style={{
              fontSize: "48px",
              fontWeight: "800",
              color: "#4f46e5",
              marginBottom: "24px",
            }}
          >
            {count}
          </div>
        )}

        {intentUrl && (
          <a
            href={intentUrl}
            style={{
              display: "block",
              width: "100%",
              padding: "14px 24px",
              backgroundColor: isError ? "#64748b" : "#4f46e5",
              color: "#ffffff",
              textDecoration: "none",
              borderRadius: "10px",
              fontWeight: "600",
              fontSize: "16px",
              boxSizing: "border-box",
              transition: "background-color 0.2s ease",
            }}
          >
            {isError ? "Return to DuePay" : "Open DuePay App"}
          </a>
        )}

        <p style={{ marginTop: "20px", fontSize: "12px", color: "#94a3b8" }}>
          If the app did not open automatically, tap the button above.
        </p>
      </div>
    </div>
  );
};

export default RedirectURLFallback;